<template>
  <div>
    <h1>Misc.</h1>

    <a v-if="siteId && siteId == 'cc6bcfb1-8af7-438f-9fa3-712eea00e8a7'" href="/files/05aa7fe5-57ba-428a-90b9-586c5d13f4d7-stats.csv" target="_blank" rel="noopener">Statistics</a>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'MiscellaneousFormComponent',
  data() {
    return {
      msg: '',
    };
  },
  computed: {
    ...mapState(['siteId'])
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
} */
</style>
